import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
export default function ObjectionsSection() {
  const faqs = [{
    q: '«¿Y si mi mente es demasiado intensa?»',
    a: 'Entonces necesitas algo aún más simple. Por eso el método es guión + cuerpo, no debate mental.'
  }, {
    q: '«No tengo disciplina.»',
    a: 'Esto no es disciplina. Es diseño: 6 minutos de descarga + un guión repetible.'
  }, {
    q: '«¿Y si hoy no funciona?»',
    a: 'No estás comprando una noche. Estás comprando un protocolo de 14 noches. El cambio principal es dejar de entrenar el patrón de pelea.'
  }, {
    q: '«Ya probé melatonina y meditaciones.»',
    a: 'Esto no es un suplemento ni una meditación. Es un sistema de 3 pasos para cortar el circuito de pensamientos. Funciona diferente.'
  }, {
    q: '«¿Necesito hacer algo complicado antes de dormir?»',
    a: 'No. Son 6 minutos de descarga + un guión mental + 3 señales físicas. Puedes hacerlo ya en la cama.'
  }, {
    q: '«¿Funciona para ansiedad severa?»',
    a: 'Este protocolo es para mente acelerada nocturna. Si tienes crisis agudas, apnea o dolor intenso, busca evaluación clínica primero. Esto complementa, no sustituye.'
  }, {
    q: '«¿Cómo sé que esto funciona?»',
    a: 'Porque no depende de tu motivación. Depende de un sistema. Y los sistemas no necesitan que estés de humor para funcionar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-brand-cream-dark" data-id="element-235">
      <h2 className="font-heading text-4xl text-white text-center mb-12 uppercase tracking-wide" data-id="element-236">
        Tal vez estás pensando…
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-237">
        {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-lg overflow-hidden bg-brand-navy shadow-sm group hover:border-brand-indigo/30 transition-colors" data-id="element-238">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none hover:bg-white/5 transition-colors" data-id="element-239">
              <span className="text-xl font-medium text-slate-200 pr-4 group-hover:text-white transition-colors" data-id="element-240">
                {faq.q}
              </span>
              <ChevronDown className={`text-brand-indigo transition-transform duration-200 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-241" />
            </button>
            <AnimatePresence data-id="element-242">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-243">
                  <div className="p-6 pt-0 text-lg text-slate-400 border-t border-white/5 leading-relaxed flex gap-4" data-id="element-244">
                    <CheckCircle2 className="text-brand-indigo flex-shrink-0 mt-1" size={20} data-id="element-245" />
                    <span data-id="element-246">{faq.a}</span>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}